export const environment = {
  production: false,
  test: false,
  API_URL: 'https://apicenter.sortiecuador.com/v1/api',
  API_FILES: 'https://apicenter.sortiecuador.com/src',
  // JWT_SECRET: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb2U...',
  API_PAYMENT: 'url',
  API_GENERATE_KEY: 'url',
  COMPANY: 'SORTI365',
  SECRET_KEY: '.....',
  SOCKET_MANAGER_URL: 'https://socket-api.zgamestech.com/',
  SOCKET_MANAGER_CHANNEL_CW_KEY: '5b98821a774da09abc41d578b826fe49bcf1a90af00e4a8025a104d2e04cdeff',
  SOCKET_MANAGER_CHANNEL_FINANCIAL_KEY: '385b545486517203cda6f678f48e0067ac9347f8eaec3c33a9b30d5abb0ff769',
  SOCKET_MANAGER_CHANNEL_TICKETS_KEY:
    '04f84a385069f0d472faa6f3f4ac5f2e682418265ff5eeff6dcec7509b45ac49',
  SOCKET_MANAGER_CHANNEL_EXTRACT_CW_KEY: 'deb620f580b0bf90ebf1a8695734f515d5ef98d156e3741384888778a0742cfd',
  ROOM_SOCKET_BOT_EXTRACT: 'bot_extract_details',
  ROOM_SOCKET_BOT_LIVE: 'bot_live_session',
  ROOM_SOCKET_TICKETS: 'tickets_dev',
  ROOM_SOCKET_CW: 'cargas_retiros_solicitud_dev',
  ROOM_SOCKET_FN: 'financial_dev',
};
